// Static texts of the quote (preview + PDF + XLSX) in each language.
// Data coming from the API (building name, address, ...) is not translated.

const EN_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const QUOTE_LANGS = [
  { value: "vi", code: "VI", label: "Tiếng Việt", hint: "Báo giá tiếng Việt" },
  { value: "en", code: "EN", label: "English", hint: "Quotation in English" },
];

export const QUOTE_MESSAGES = {
  vi: {
    modalTitle: "Chỉnh sửa báo giá sản phẩm",
    coverTitleLine1: "TỔNG HỢP",
    coverTitleLine2: "VĂN PHÒNG PHÙ HỢP NHẤT",
    recipientPlaceholder: "Nhập người nhận",
    datePlaceholder: "Nhập ngày tháng",
    phonePlaceholder: "Số điện thoại",
    emailPlaceholder: "Email",
    websitePlaceholder: "Website",
    addressPlaceholder: "Địa chỉ",
    defaultRecipient: "To: ",
    defaultCompanyAddress: "Tầng 9, Diamond Plaza, 34 Lê Duẩn, Q.1",
    defaultFloor: "Tầng ",
    defaultVacantTime: "Đang trống",
    formatDate: (d) =>
      `TP.HCM, Ngày ${d.getDate()} Tháng ${
        d.getMonth() + 1
      } Năm ${d.getFullYear()}`,
    stt: "STT",
    image: "HÌNH ẢNH",
    contact: "Liên hệ:",
    department: "Sales Department",
    usd: "usd",
    vnd: "vnd",
    rows: {
      name: "TÊN TOÀ NHÀ",
      rank: "HẠNG",
      address: "ĐỊA CHỈ",
      structure: "KẾT CẤU",
      area: "DIỆN TÍCH THUÊ",
      floor: "TẦNG",
      basicRent: "ĐƠN GIÁ THUÊ",
      serviceCost: "PHÍ QL/DV",
      unitRentAndService: "ĐƠN GIÁ THUÊ & PQL",
      totalUsd: "TỔNG TIỀN THUÊ & PQL",
      totalVnd: "TỔNG TIỀN THUÊ & PQL",
      vacantTime: "THỜI GIAN TRỐNG",
      overTimeCost: "PHÍ NGOÀI GIỜ",
      deposit: "ĐẶT CỌC",
      payment: "THANH TOÁN",
      motorPark: "PHÍ GỬI XE MÁY",
      carPark: "PHÍ GỬI Ô TÔ",
      fitOut: "THỜI GIAN FIT-OUT",
      website: "LINK WEBSITE",
      note: "GHI CHÚ",
    },
    units: {
      m2: "(m2)",
      usdPerM2Month: "($/m2/month)",
      usd: "(USD)",
      vnd: "(VND)",
      perVehicleMonth: "(/XE/THÁNG)",
    },
    langModalTitle: "Chọn loại báo giá",
    langModalHint: "Bạn muốn tạo báo giá bằng ngôn ngữ nào?",
    sheetName: "Bao gia",
    fileName: "bao-gia-tong-hop",
  },
  en: {
    modalTitle: "Edit product quotation",
    coverTitleLine1: "OFFICE OPTIONS PROPOSAL",
    coverTitleLine2: "", // single-line title in the customer's file
    recipientPlaceholder: "Recipient",
    datePlaceholder: "Date",
    phonePlaceholder: "Phone number",
    emailPlaceholder: "Email",
    websitePlaceholder: "Website",
    addressPlaceholder: "Address",
    defaultRecipient: "To: ",
    defaultCompanyAddress: "Diamond Plaza, 34 Le Duan, Saigon Ward, HCM",
    defaultFloor: "Floor ",
    defaultVacantTime: "Now",
    // wording below follows the customer's "BAO GIA TONG HOP (E).xlsx"
    formatDate: (d) =>
      `TP.HCM, ${EN_MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`,
    stt: "No.",
    image: "PICTURE",
    contact: "Contact:",
    department: "Sales Department",
    usd: "USD",
    vnd: "VND",
    rows: {
      name: "BUILDING",
      rank: "GRADE",
      address: "ADDRESS",
      structure: "STRUCTURE",
      area: "SPACE AVAILABLE",
      floor: "FLOOR",
      basicRent: "RENT",
      serviceCost: "SERVICE CHARGE",
      unitRentAndService: "RENT & S.C",
      totalUsd: "TOTAL",
      totalVnd: "TOTAL",
      vacantTime: "AVAILABLE FROM",
      overTimeCost: "OVERTIME FEES",
      deposit: "DEPOSIT",
      payment: "PAYMENT",
      motorPark: "MOTOBIKE PARKING FEE", // verbatim from the customer's file
      carPark: "CAR PARKING FEE",
      fitOut: "FIT-OUT PERIOD",
      website: "LINK WEBSITE",
      note: "NOTE",
    },
    units: {
      m2: "(m2)",
      usdPerM2Month: "($/m2/month)",
      usd: "(USD)",
      vnd: "(VND)",
      perVehicleMonth: "", // the customer's file has no unit here
    },
    langModalTitle: "Choose quotation type",
    langModalHint: "Which language should the quotation be in?",
    sheetName: "Quotation",
    fileName: "quotation-summary",
  },
};

export function getQuoteMessages(lang) {
  return QUOTE_MESSAGES[lang] || QUOTE_MESSAGES.vi;
}

// Header/footer artwork per language (the footer has its text baked in).
// footer_quote_en.jpg: the customer's english footer ("BAO GIA TONG HOP (E).xlsx",
// only 1025x725 there) rebuilt at 2x: logos/icons/Galaxy logo are the real
// high-resolution pixels of footer_quote.jpg, the english text is an AI
// (Real-ESRGAN) upscale checked by eye; wording kept exactly as delivered.
export const QUOTE_IMAGES = {
  vi: {
    header: require("@/assets/images/header_quote.jpg"),
    footer: require("@/assets/images/footer_quote.jpg"),
  },
  en: {
    header: require("@/assets/images/header_quote.jpg"),
    footer: require("@/assets/images/footer_quote_en.jpg"),
  },
};
